import React from "react"
import {
    Box,
    ColorSchemes,
    componentStyles,
    Divider,
    IconButton,
    Orientation,
    PillButton,
    SIZES,
} from "@mallardbay/lib-react-components"

import SparkleIcon from "~components/shared/icons/sparkle-icon"
import { useMaybeOutfitterAssistant } from "~contexts/outfitter-assistant-provider"
import COPY from "~config/copy-constants"
import { PAGE_HEADER_DIVIDER_HEIGHT, TEST_IDS } from "~config/constants"
import { useIsMobile } from "~utils/hooks/use-responsive"
import { ASSISTANT_HEADER_BUTTON_TRANSITION } from "~components/outfitter-assistant/assistant-presentation-motion"
import {
    ASSISTANT_HEADER_BUTTON_GAP,
    ASSISTANT_HEADER_BUTTON_MAX_WIDTH,
} from "~components/outfitter-assistant/outfitter-assistant-constants"

const ICON_SIZE = 18

export default function AssistantHeaderButtonContent() {
    const styles = useStyles()
    const assistant = useMaybeOutfitterAssistant()
    const isMobile = useIsMobile()

    if (!assistant) return null

    const sharedButtonProps = {
        testId: TEST_IDS.OUTFITTER_ASSISTANT_BUBBLE,
        onClick: assistant.toggle,
        size: SIZES.MD,
    }
    const sparkleIcon = <SparkleIcon size={ICON_SIZE} />

    if (isMobile) {
        return (
            <IconButton
                {...sharedButtonProps}
                icon={sparkleIcon}
                colorScheme={ColorSchemes.Brand}
                ariaLabel={COPY.OUTFITTER_ASSISTANT_OPEN_ARIA}
            />
        )
    }

    // On desktop the assistant opens as a side panel, so the header button is
    // redundant (and the panel has its own close button) while it's open. We
    // keep it rendered and collapse it with CSS so the hide/show is animated.
    const desktopContainerStyle = assistant.isOpen
        ? { ...styles.desktopContainer, ...styles.desktopContainerHidden }
        : styles.desktopContainer

    return (
        <Box style={desktopContainerStyle} aria-hidden={assistant.isOpen}>
            <Box style={styles.divider}>
                <Divider orientation={Orientation.Vertical} />
            </Box>
            <PillButton
                {...sharedButtonProps}
                leftIcon={sparkleIcon}
                gradientEnabled
            >
                {COPY.OUTFITTER_ASSISTANT_NAME}
            </PillButton>
        </Box>
    )
}

function useStyles() {
    return componentStyles({
        divider: {
            height: PAGE_HEADER_DIVIDER_HEIGHT,
        },
        desktopContainer: {
            display: "flex",
            alignItems: "center",
            gap: ASSISTANT_HEADER_BUTTON_GAP,
            overflow: "hidden",
            maxWidth: ASSISTANT_HEADER_BUTTON_MAX_WIDTH,
            opacity: 1,
            transition: ASSISTANT_HEADER_BUTTON_TRANSITION,
        },
        desktopContainerHidden: {
            maxWidth: 0,
            opacity: 0,
            visibility: "hidden",
            marginLeft: `-${ASSISTANT_HEADER_BUTTON_GAP}`,
        },
    })
}
